export const ConversationProvider = {
    VIRTUAL_AGENT: 'VIRTUAL_AGENT',
    AI_ANSWERS: 'AI_ANSWERS',
} as const;

export type ConversationProvider = (typeof ConversationProvider)[keyof typeof ConversationProvider];
